<template>
  <div>
    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-6">
        <h4 class="mb-1 mt-0">Profile</h4>
      </div>
    </div>

    <!-- Nitro Booster Subscription Banner -->
    <div v-if="isBundleUser" class="row mb-3">
      <div class="col-12">
        <div class="card border-primary">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0">
                <div class="rounded-circle bg-primary p-2 d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                  <i class="uil uil-rocket text-white" style="font-size: 24px;"></i>
                </div>
              </div>
              <div class="flex-grow-1 ms-3 ml-3">
                <h5 class="mb-1 text-primary">Customer Engine: Nitro Booster</h5>
                <p class="text-muted mb-0">
                  Your subscription is managed through the Nitro Booster bundle.
                  <span v-if="bundleLinkedAt" class="d-block small mt-1">
                    Connected since {{ bundleLinkedAt | shorttime }}
                  </span>
                </p>
              </div>
              <div class="flex-shrink-0">
                <a 
                  href="https://nitro.customerengine.io/user" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  class="btn btn-outline-primary btn-sm"
                >
                  Manage Subscription <i class="uil uil-external-link-alt"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <ValidationObserver v-slot="{ handleSubmit, invalid, touched }" ref="updateForm">
              <form class="authentication-form" @submit.prevent="handleSubmit(updateProfile)">
                <div class="row">
                  <div class="col-md-6">
                    <TextInput v-model="user.first_name" name="first_name" rules="required" label="First Name" />
                  </div>
                  <div class="col-md-6">
                    <TextInput v-model="user.last_name" name="last_name" rules="required" label="Last Name" />
                  </div>
                  <div class="col-md-6">
                    <TextInput 
                      v-model="user.email" 
                      name="email" 
                      rules="required|email" 
                      label="Email"
                      :disabled="isBundleUser"
                    />
                    <small v-if="isBundleUser" class="text-muted">
                      <i class="uil uil-lock"></i> Email is managed by Nitro Booster
                    </small>
                  </div>
                </div>
                <b-form-group>
                  <b-button variant="primary" :disabled="loadingUpdate || (invalid && touched)" type="submit">
                    <b-spinner v-if="loadingUpdate" small />
                    <span v-else>Update</span>
                  </b-button>
                </b-form-group>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>

    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-6">
        <h4 class="mb-1 mt-0">Change password</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <ValidationObserver v-slot="{ handleSubmit, invalid, touched }" ref="passwordForm">
              <form class="authentication-form" @submit.prevent="handleSubmit(changePassword)">
                <div class="row">
                  <div class="col-md-6">
                    <TextInput v-model="password.password" name="password" rules="required|confirmed:confirm_password"
                      label="Password" type="password" />
                  </div>
                  <div class="col-md-6">
                    <TextInput v-model="password.password_confirmation" vid="confirm_password" name="confirm_password"
                      rules="required" label="Confirm Password" type="password" />
                  </div>
                </div>
                <b-form-group>
                  <b-button variant="primary" :disabled="loadingPassword || (invalid && touched)" type="submit">
                    <b-spinner v-if="loadingPassword" small />
                    <span v-else>Change</span>
                  </b-button>
                </b-form-group>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  data() {
    return {
      loadingUpdate: false,
      loadingPassword: false,
      user: {
        agency: {
          twilioConfig: {},
          whitelabel: {},
        },
      },
      password: {
        password: '',
        password_confirmation: '',
      },
    }
  },

  computed: {
    currentUser() {
      return this.$store.getters['auth/user']
    },

    isBundleUser() {
      return this.currentUser && !!this.currentUser.bundle_user_id
    },

    bundleLinkedAt() {
      return this.currentUser && this.currentUser.bundle_linked_at
    },
  },

  mounted() {
    this.user = Vue.util.extend({}, this.$store.getters['auth/user'])
  },

  methods: {
    updateProfile() {
      this.loadingUpdate = true

      this.$store
        .dispatch('auth/updateProfile', this.user)
        .then(() => {
          this.loadingUpdate = false
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.updateForm.setErrors(err.response.data.errors)
          }
          this.loadingUpdate = false
        })
    },

    changePassword() {
      this.loadingPassword = true

      this.$store
        .dispatch('user/changePassword', this.password)
        .then(() => {
          this.password = {}
          this.loadingPassword = false
          this.$refs.passwordForm.reset()
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.passwordForm.setErrors(err.response.data.errors)
          }
          this.loadingPassword = false
        })
    },
  },
}
</script>
